module.exports = __webpack_public_path__ + "img/esport-3.bd4a0011.svg";